import {
    HorizontalContainer,
    HorizontalSpaceBetween,
    VerticalContainer
} from '@american-autonomy/ag-ui';

import WearBar from 'components/WearBar';
import CautionStatusBadge from 'components/badges/CautionStatusBadge';
import GoodStatusBadge from 'components/badges/GoodStatusBadge';
import StatusBadge from 'components/badges/StatusBadge';
import BodyText from 'components/text/BodyText';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props, StatusBadgeComponent } from './types';

import styles from './styles.module.scss';

const statusBadgeMap: Record<Props['status'], StatusBadgeComponent> = {
    COMPLIANT: GoodStatusBadge,
    DUE: CautionStatusBadge,
    NOT_REPORTED: StatusBadge,
    OK: GoodStatusBadge,
    OUTDATED: CautionStatusBadge
};

const ComponentStatusRow: FunctionComponent<Props> = ({
    className = '',
    detail,
    label,
    percentRemaining,
    status,
    testId = TEST_ID
}) => {
    const statusLabels = useTranslation();
    const StatusBadgeVariant = statusBadgeMap[status];
    const detailText = detail ? <BodyText className={styles.detail} text={detail} /> : null;
    const wearBar =
        percentRemaining === undefined ? null : (
            <WearBar className={styles.wearBar} percentRemaining={percentRemaining} />
        );

    return (
        <VerticalContainer className={`${className} ${styles.componentStatusRow}`} testId={testId}>
            <HorizontalSpaceBetween className={styles.content}>
                <HorizontalContainer className={styles.labelAndDetail}>
                    <BodyText className={styles.label} text={label} />

                    {detailText}
                </HorizontalContainer>

                <StatusBadgeVariant text={statusLabels[status]} />
            </HorizontalSpaceBetween>

            {wearBar}
        </VerticalContainer>
    );
};

export default ComponentStatusRow;
